export default "__VITE_ASSET__BewtVWWZ__"